import React from 'react'
import './features.css'
import '../../components/feature/feature.css'
import Feature from '../../components/feature/Feature'

const featuresData = [
  {
    title: 'Order ambulance',
    text: 'Our platform organises ambulances and EMS service providers; So you can easily access them on your phone affordably and conveniently, the only app of its kind in Uganda.',
  },
  {
    title: 'Report an accident',
    text: 'We collaborate with the authorities and notify them about the valid accidents you report through our app, so they can act and respond fast. This improves their perfomance and service delivery.',
  },
  {
    title: 'Find a hospital',
    text: 'Hospitals are highlighted as green areas on the map in our app; easy to notice and distinguished; this enables you to find directions and navigate to them easily and conveniently.',
  },
  {
    title: 'Get medical cover',
    text: 'For your family; get a medical cover provided by one of our partners. In the event of an emergency, you are assured of medical evac and rescue coming to you or them to provide assistance.',
  },
]

const Features = () => {
  return (
    <div className='taasa__features section__padding' id="features">
      <div className='taasa__features-heading'>
        <h1 className='gradient__text'>
          It requires expertise and fast decision-making to preserve a life in an emergency, we know it's hard so we do it for you.
          <p>Here are some of the features in our app to help you</p> 
        </h1>               
      </div>
      <div className='taasa__features-container'>
        {featuresData.map((item, index) => (
          <Feature title={item.title} text={item.text} key={item.title + index }/>
        ))}
      </div>
    </div>
  )
}

export default Features